import React from 'react';
import PropTypes from 'prop-types';
import {Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

const DefectQtyTrends = (props) => {
	return (
		<ResponsiveContainer height={props.height}>
			<BarChart data={props.data} margin={{top: 20, bottom: 20}} layout="vertical">
				<CartesianGrid strokeDasharray="3 3"/>
				<XAxis type="number" />
				<YAxis type="category" dataKey="name" width={80}/>
				<Tooltip/>
				<Bar dataKey="value" label={{ position: 'right' }} maxBarSize={40}/>
			</BarChart>
		</ResponsiveContainer>
	)
};

DefectQtyTrends.defaultProps = {
	height: 140
};

DefectQtyTrends.propTypes = {
	data: PropTypes.array.isRequired,
	height: PropTypes.number
};

export default DefectQtyTrends;
